import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_RAID_RANKINGS, GET_RAID_RANKINGS_ERROR, SHOW_RAID_RANKINGS_SPINNER } from '../actions/getRaidRankings';
import { TAction } from '../actions/types/action';
import { TRaidRankingsClientReducer } from '../libs/store';

const DEFAULT_STATE = {
  instances: {}
};

export default function raidRankings(
  state: Partial<any> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TRaidRankingsClientReducer> {
  switch (action.type) {
    case GET_RAID_RANKINGS: {
      return {
        ...state,
        instances: {
          ...state.instances,
          default: action.payload.data,
          [action.payload.instanceId]: action.payload.data
        }
      };
    }
    case GET_RAID_RANKINGS_ERROR: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            isError: true,
            error: action.payload.error
          }
        }
      };
    }
    case SHOW_RAID_RANKINGS_SPINNER: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            uiLoading: action.payload.show
          }
        }
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      if (action.payload.location?.state?.hash) {
        return state;
      }
      if (action.payload.hash && action.payload.hash.length > 0) {
        return state;
      } else {
        return DEFAULT_STATE;
      }
    }
    default: {
      return state;
    }
  }
}
